import { defineMessages } from '@jutro/locale';

export default defineMessages({
    yourHome: {
        id: 'quoteandbind.ho.wizard.step.Your Home',
        defaultMessage: 'Home'
    },
    construction: {
        id: 'quoteandbind.ho.wizard.step.Property Details',
        defaultMessage: 'Property Details'
    },
    discount: {
        id: 'quoteandbind.ho.wizard.step.Discounts',
        defaultMessage: 'Discounts'
    },
    additionalOptional: {
        id: 'quoteandbind.ho.views.rating.Additional (optional)',
        defaultMessage: 'Additional (optional)'
    },
    anErrorOccurred: {
        id: 'quoteandbind.ho.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.ho.wizard.error.title',
        defaultMessage: 'Error'
    },
    safetyNet: {
        id: 'quoteandbind.ho.views.rating.Trampoline has a safety net',
        defaultMessage: 'Does the trampoline have a safety net?'
    },
    mlHoYourInfoHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.YourInfo.header',
        defaultMessage: 'Tell us about yourself'
    },
    mlQualificationHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.Qualification.header',
        defaultMessage: 'What else should we know about you?'
    },
    mlAdditionalInfoToQuoteHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.AdditionalInfoToQuote.header',
        defaultMessage: 'Last questions before your quote'
    },
    mlESignatureHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.ESignature.header',
        defaultMessage: 'Sign below to complete your purchase'
    },
    mlHoQuotePageHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.QuotePage.header',
        defaultMessage: 'Your home insurance quote'
    },
    mlHoDiscountsHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.Discounts.header',
        defaultMessage: 'Find even more discounts'
    },
    mlHoProductSelectionHeader: {
        id: 'ml.quoteandbind.ho.wizard.step.ProductSelection.header',
        defaultMessage: 'Help us find the type of product to suit you'
    },
    mlAdditionalDetails: {
        id: 'ml.quoteandbind.ho.wizard.step.Additional Details',
        defaultMessage: 'Additional Details'
    }
});
